module.exports = __webpack_public_path__ + "img/T1C_rc_5.2fa9e58c.png";